import React, { Component } from "react";
import LocalizedStrings from "react-localization";
import en from "../localization/localization-en.json";

import { getUser, renderErrorMessage } from "../helper/user_helper";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faQuestion,
  faBookOpen,
  faImage
} from "@fortawesome/free-solid-svg-icons";
import CreateQuestionTextArea from "../components/create_question/create_question";
import Loader from "../components/loader";
import CreateImageLine from "../components/create_question/create_image_line";
import { getCategories } from "../helper/category_helper";
import { createQuestion } from "../helper/question_helper";

// import CategorySelection from "../components/categories/category_selection";

import CreateList from "../components/create_list/create_list";

import CreateRecommendationPage from "../components/create_recommendation/create_recommendation_page";

import qs from "qs";

let strings = new LocalizedStrings({ en });

class CreateQuestion extends Component {
  state = {
    user: null,
    loaded: true,
    errors: "",
    image: null,
    imageFile: null,
    question: "",
    type: "questions",
    categories: [],
    selected_categories: null,
    hashtag: ""
  };

  componentDidMount() {
    // Check if user is already login
    const self = this;

    this.userCall = getUser();
    this.userCall.promise.then(answer => {
      if (answer.signedIn === false) {
        self.props.history.push("/profile");
        return;
      }
      const user = answer.user;
      self.setState({ user });
    });

    const query = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true
    });
    if (query.hashtag) {
      this.setState({ hashtag: query.hashtag });
    }

    this.categoriesCall = getCategories();
    this.categoriesCall.promise.then(answer => {
      const categories = answer.categories;
      self.setState({ categories });
    });
  }

  componentWillUnmount() {
    if (this.userCall) {
      this.userCall.cancel();
    }
    if (this.categoriesCall) {
      this.categoriesCall.cancel();
    }
    if (this.createQuestionCall) {
      this.createQuestionCall.cancel();
    }
  }

  handleChangeToQuestion = e => {
    const type = "questions";
    this.setState({ type });
  };
  handleChangeToAnswer = e => {
    const type = "answers";
    this.setState({ type });
  };

  questionChanged = e => {
    this.setState({ question: e.target.value });
  };

  render() {
    if (this.state.user === null) {
      return <Loader loaded={false} />;
    }
    return (
      <div className="allow_scroll profilePage page_top_nav list">
        {this.renderQuestionTypeSelection()}
        {this.renderCreateFollowingType()}
      </div>
    );
  }

  selectCategory = category => {
    const selected_categories = category;
    this.setState({ selected_categories });
  };

  renderCreateFollowingType() {
    if (this.state.type === "questions") {
      const style = {
        display: "block",
        position: "absolute",
        margin: "0px",
        width: "100%",
        height: "100%",
        textTransform: "capitalize"
      };
      const style_image = {
        position: "absolute",
        right: "-10px",
        bottom: "-5px"
      };
      return (
        <form onSubmit={this.createQuestion}>
          <div className="row max_width_500 pt-2">
            <div
              className="question_answer_v2 center width_100"
              style={{ paddingBottom: "0px" }}
            >
              {/* <div
                className="question_v2 "
                style={{ marginLeft: "0px", marginRight: "0px" }}
              > */}
              <CreateQuestionTextArea
                questionChanged={this.questionChanged}
                question={this.state.question}
                user={this.state.user}
                category={this.state.selected_categories}
                categories={this.state.categories}
                selectCategory={this.selectCategory}
              />
              {this.renderImageQuestion()}
              {/* </div> */}
            </div>
          </div>
          <div className="center">
            {renderErrorMessage(this.state.errors)}
            <br />
            <div className="row max_width_500 bottom_right width_100">
              <div className="width_image_question" />
              <div className="width_text_question" />
              <div className="width_image_question">
                <div className="user_img" style={style_image}>
                  <input
                    style={style}
                    type="submit"
                    value={strings.post}
                    className="btn btn_primary btn_yaystack no_border"
                  />
                </div>
              </div>
            </div>

            <label
              htmlFor="image-upload"
              className="yaystack_color btn_create bottom_left"
            >
              <FontAwesomeIcon icon={faImage} />
            </label>
            <input
              type="file"
              className="input-file btn btn_primary btn_yaystack bottom_left"
              // capture="camera"
              accept="image/*"
              id="image-upload"
              name="image-upload"
              onChange={this.handleChangeImage}
            />
          </div>
        </form>
      );
    }
    return (
      <div className="center max_width_500 margin-top-1 ">
        <CreateList
          loaded={this.state.loaded}
          handleUpdateLoaded={this.handleUpdateLoaded}
          handleGoToPage={this.handleGoToPage}
          hashtag={this.state.hashtag}
          user={this.state.user}
          history={this.props.history}
        />
      </div>
    );
  }

  renderQuestionTypeSelection() {
    if (this.state.loaded === false) {
      return <div />;
    }
    var questionClass = "btn btn_primary selection ";
    var answerClass = "btn btn_primary selection ";
    if (this.state.type === "questions") {
      questionClass += "selection_active";
    } else if (this.state.type === "answers") {
      answerClass += "selection_active";
    }

    return (
      <div className="row create_question_row">
        <div className="width_profile_selection width_create_selection">
          <button
            className={questionClass}
            onClick={this.handleChangeToQuestion}
            style={{ fontFamily: "DIN Pro Black", fontSize: "23px" }}
          >
            Q/A
            {/* <FontAwesomeIcon icon={faQuestion} /> */}
          </button>
        </div>
        <div className="width_profile_selection width_create_selection">
          <button className={answerClass} onClick={this.handleChangeToAnswer}>
            <FontAwesomeIcon icon={faBookOpen} />
          </button>
        </div>
      </div>
    );
  }

  renderImageQuestion() {
    if (this.state.image == null) {
      return <div />;
    }
    return (
      <CreateImageLine
        image={this.state.image}
        handleRemoveImage={this.handleRemoveImage}
      />
    );
  }

  handleRemoveImage = event => {
    const image = null;
    const imageFile = null;
    this.setState({ image, imageFile });
  };

  handleChangeQuestion = event => {
    this.setState({ question: event.target.value });
  };

  handleChangeImage = event => {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = e => {
        this.setState({
          image: e.target.result
        });
      };
      this.setState({ imageFile: event.target.files[0] });
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  createQuestion = event => {
    event.preventDefault();
    // Checking if one category is selected
    if (this.state.selected_categories === null) {
      const errors = strings.category_require;
      this.setState({ errors });
      return;
    }
    // Checking minimum length of the question
    if (this.state.question.length < 8) {
      const errors = strings.question_too_short;
      this.setState({ errors });
      return;
    }
    this.setState({ loaded: false });

    var fd = new FormData();
    fd.append("question[name]", this.state.question);
    fd.append("question[category_id]", this.state.selected_categories.id);
    if (this.state.image !== null) {
      fd.append("question[image]", this.state.imageFile);
    }
    const self = this;
    this.createQuestionCall = createQuestion(fd);
    this.createQuestionCall.promise
      .then(answer => {
        self.props.history.push("/question/");
      })
      .catch(error => {
        self.setState({ loaded: true, errors: error.errors });
      });
  };

  handleUpdateLoaded = loaded => {
    this.setState({ loaded });
  };

  handleGoToPage = page => {
    this.props.history.push(page);
  };
}

export default CreateQuestion;



// WEBPACK FOOTER //
// ./src/pages/createQuestion.jsx